import { render, staticRenderFns } from "./IngredientsTableMobile.vue?vue&type=template&id=233d3e77&scoped=true&lang=pug"
import script from "./IngredientsTableMobile.vue?vue&type=script&lang=js"
export * from "./IngredientsTableMobile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "233d3e77",
  null
  
)

export default component.exports